var dataLayer = dataLayer || [];
( function () {
    'use strict';
    /**
     * @namespace
     */
    master.tracking = {
        /** @function */
        /**
         * Helper to track after page loads
         */
        trackAfterPageLoad: function () {
            if ( sessionStorage.totrack ) {
                var trackObject = JSON.parse( sessionStorage.totrack ),
                    trackingFn = trackObject.fn,
                    trackingArgs = trackObject.args;
                master.tracking[ trackObject.fn ].apply( this, trackingArgs );
                sessionStorage.removeItem( 'totrack' );
            }
        },
        /** @function */
        /**
         * Set object to track and save

         * @param {object} toTrack
         */
        toTrack: function ( toTrack ) {
            if ( typeof toTrack === 'object' ) {
                sessionStorage.totrack = JSON.stringify( toTrack );
            }
        },
        /** @function */
        /**
         * Track search
         */
        search: function () {
            var searchQuery = co3.util.param.q;
            if ( searchQuery !== undefined ) {
                var resultCategory = jQuery( '.js-search-no-results' ).length ? 'Search – zero results' : 'Search';
                dataLayer.push( {
                    'eventCategory': resultCategory,
                    'eventAction': searchQuery,
                    'eventLabel': '',
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            }
        },
        /** @function */
        /**
         * Track workshop selected
         * @param {string} workshop
         * @param {string} url
         * @param {string} typeOfSelection
         */
        workshop: function ( workshop, url, typeOfSelection ) {
            //if ( sessionStorage.workshopSelected !== undefined ) {
            if ( workshop === undefined || workshop === null || workshop === '' ) {
                workshop = jQuery( 'meta[name="workshopName"]' ).attr( 'content' );
            }
            dataLayer.push( {
                'eventCategory': 'Valg af værksted',
                'eventAction': typeOfSelection,
                'eventLabel': url,
                'eventValue': 0,
                'eventInteraction': true,
                'event': 'track-ga-event'
            } );
            if ( workshop !== null ) {
                dataLayer.push( {
                    'eventCategory': 'Valgt værksted',
                    'eventAction': workshop,
                    'eventLabel': url,
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            }
            //}
            sessionStorage.removeItem( 'workshopSelected' );
        },
        /** @function */
        /**
         * Track Newsletter signup
         */
        newsletterSignup: function () {
            dataLayer.push( {
                'eventCategory': 'Newsletter',
                'eventAction': 'Signup',
                'eventLabel': 'Popup',
                'eventValue': 0,
                'eventInteraction': true,
                'event': 'track-ga-event'
            } );
        },
        /** @function */
        /**
         * Track Completed purchace
         */
        compleledPurchace: function () {
            if ( jQuery( '.js-custom-dimension-tracking' ).length ) {
                var customertype = jQuery( '.js-custom-dimension-tracking' ).data( 'customer-type' ),
                    workshop = jQuery( '.js-custom-dimension-tracking' ).data( 'workshop' );
                dataLayer.push( {
                    'LoggedOn': customertype,
                    'event': 'LoggedOnDone'
                } );
                dataLayer.push( {
                    'Vaerksted': workshop,
                    'event': 'VaerkstedDone'
                } );
            }
        },
        /**
         * @namespace
         */
        ecom: {
            prevQuantity: parseInt( sessionStorage.itemsInCart ),
            currentQuantity: parseInt( jQuery( '.js-inline-cart-quantity' ).text() ) || 0,
            /** @function */
            /**
             * Track add product to cart
             */
            addProduct: function () {
                var trackingData = sessionStorage.trackingData !== undefined ? JSON.parse( sessionStorage.trackingData ) : undefined;
                if ( trackingData !== undefined ) {
                    dataLayer.push( {
                        'event': 'addToCart',
                        'ecommerce': {
                            'currencyCode': trackingData.currencyCode,
                            'add': {
                                'products': trackingData.productData
                            }
                        }
                    } );
                }
                sessionStorage.removeItem( 'trackingData' );
            },
            /** @function */
            /**
             * Track remove product from cart
             */
            removeProduct: function () {
                var trackingData = sessionStorage.trackingData !== undefined ? JSON.parse( sessionStorage.trackingData ) : undefined;
                if ( trackingData !== undefined ) {
                    dataLayer.push( {
                        'event': 'removeFromCart',
                        'ecommerce': {
                            'currencyCode': trackingData.currencyCode,
                            'remove': {
                                'products': trackingData.productData
                            }
                        }
                    } );
                }
                sessionStorage.removeItem( 'trackingData' );
            },
            actions: {
                /** @function */
                /**
                 * Track Update orderline
                 */
                updateOrderline: function () {
                    jQuery( '.js-cart-delte-orderline, .js-e-orderline-btn-update-cart, .js-e-orderline-decrement-link, .js-e-orderline-increment-link' ).on( 'click', function () {
                        var jOrderline = jQuery( this ).parents( '.js-e-orderline' ),
                            jQuantity = parseInt( jOrderline.find( '.js-e-orderline-quantity' ).val() ),
                            trackingData = {};
                        trackingData.currencyCode = jOrderline.find( '.js-tracking-product-data' ).data( 'currency' );
                        trackingData.productData = eval( jOrderline.find( '.js-tracking-product-data' ).html() );
                        trackingData.productData[ 0 ].quantity = jQuantity;
                        sessionStorage.trackingData = JSON.stringify( trackingData );
                    } );
                },
                addToCart: function () {
                    /** @function */
                    /**
                     * Track Add to cart
                     */
                    jQuery( '.js-add-to-cart-button' ).on( 'click', function () {
                        var jForm = jQuery( this ).parents( 'form' ),
                            jQuantity = parseInt( jForm.find( '.js-add-to-cart-quantity' ).val() ),
                            trackingData = {};
                        trackingData.currencyCode = jForm.find( '.js-tracking-product-data' ).data( 'currency' );
                        trackingData.productData = eval( jForm.find( '.js-tracking-product-data' ).html() );
                        trackingData.productData[ 0 ].quantity = jQuantity;
                        sessionStorage.trackingData = JSON.stringify( trackingData );
                    } );
                },
                init: function () {
                    this.updateOrderline();
                    this.addToCart();
                }
            },
            init: function () {
                this.actions.init();
                if ( sessionStorage.itemsInCart !== undefined ) {
                    if ( this.currentQuantity > this.prevQuantity ) {
                        this.addProduct();
                    }
                    else if ( this.currentQuantity < this.prevQuantity ) {
                        this.removeProduct();
                    }
                }
                sessionStorage.itemsInCart = this.currentQuantity;
            }
        },
        init: function () {
            master.tracking.trackAfterPageLoad();
            master.tracking.search();
            //if ( jQuery( 'meta[name="workshopID"]' ).length === 1 ) {
            //    master.tracking.workshop( sessionStorage.workshopSelected, location.href );
            //}
            master.tracking.compleledPurchace();
            master.tracking.ecom.init();
        }
    };
}() );
